import { Component, Input } from '@angular/core';

@Component({
  selector: 'p-photo-miniature',
  templateUrl: './p-photo-miniature.component.html',
  styleUrls: ['./p-photo-miniature.component.scss'],
})
export class PPhotoMinatureComponent {
  @Input() imageUrl?: string;
}
